<template>
  <v-row justify="center">
    <v-dialog
      :value="true"
      persistent
      max-width="900px"
    >
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <v-card-title>
                  Survey for {{ survey.customer }}
                </v-card-title>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                sm="12"
              >
                <p class="pl-4">
                  Date: {{ survey.date | prettyDate }}
                  <span v-if="survey.am">AM</span>
                  <span v-else>PM</span>
                </p>
                <p class="pl-4">Address: {{ survey.address }}</p>
                <p class="pl-4">
                    <v-btn
                        small
                        color="blue-grey lighten-4"
                        @click="$store.commit('setSurvey', 0)"
                    >
                    <v-icon left>
                      mdi-close
                    </v-icon>
                    Close
                  </v-btn>
                </p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from '../../axios';

export default {
  name: 'ViewSurvey',
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  data() {
    return {
      dialog: false,
      survey: {},
    };
  },
  methods: {
    getSurvey() {
      const surveyId = this.$store.state.selectedSurveyId;
      axios.get(`/siteSurveys/getOne/${surveyId}.json?token=${this.token}`)
        .then((response) => {
          this.survey = response.data.survey;
        });
    },
  },
  mounted() {
    this.getSurvey();
  },
};
</script>
